export default __webpack_public_path__ + "static/media/insta.e9010f6d.jpg";